import { Backdrop, CircularProgress, Fade } from '@mui/material'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { EditModalProps } from '../../../pages/vendors/models'
import { modalStyles } from '../../ModalStyles'
import APIIntegration from './APIIntegration';
import BillToInformation from './BillToInformation'
import CarrierRemarks from './CarrierRemarks'
import MainInformation from './MainInformation'
import * as Yup from 'yup';
import axios from 'axios'
import { actionTypes } from '../../../modules/auth/redux/PagesRedux'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { CountryOptions } from '../../../data/CountryOptions'
import { ModalStyled } from '../../Modals.styled'
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall'
import { RootState } from '../../../../setup'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import { clearDialCode } from '../../../helpers/clearDialCode'
import { formatPhone } from '../../../helpers/formatPhone'
import PDFHeaderBranding from './PDFHeaderBranding'
import { UserModel } from '../../../modules/auth/models/UserModel'

const TEST_CONNECTION = '/applet/v1/rate/test'
const GET_VENDORS = '/api/v1/database/vendor'

const EditModal = ({open, setOpen, rowSelected, setRowSelected, getData, addOrEdit}: EditModalProps) => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const classes = modalStyles({})
    const dispatch = useDispatch()
    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            if(rowSelected?.id){
                setRowSelected({})
            }
            setCurrentIdRowToEdit(null)
            formik.handleReset({})
        }, 500);
    }
    const [vendorsTypes, setVendorsTypes] = useState([])
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const [testingConnection, setTestingConnection] = useState(false)
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [availableApis, setAvailableApis] = useState([])
    const [addOrEditLocal, setAddOrEditLocal] = useState(addOrEdit)
    const [currentIdRowToEdit, setCurrentIdRowToEdit] = useState(null)
    const [APISelected, setAPISelected] = useState({})

    const initialValues = {
        mainInformation: {
            name: '',
            terms: 'Prepaid',
            billTo: 'Third Party',
            address: '',
            address1: '',
            city: '',
            state: '',
            zipcode: '',
            country: 'US',
            phone: '',
            fax: '',
            contactPerson: '',
            email: '',
            vendorType: '',
            shipmentMode: {},
            remarks: '',
            equipments: [],
            serviceArea: [],
        },
        APIIntegration: {
            APIList: '',
            username: '',
            password: '',
            account: '',
            accessCode: '',
            extraField: '',
            restrictions: {
                maximums: {
                    pieces: 0,
                    pieceWeight: 0,
                    pieceLength: 0,
                    pieceWidth: 0,
                    pieceHeight: 0,
                    totalWeight: 0,
                    CFT: 0
                },
                minimums: {
                    pieces: 0,
                    pieceWeight: 0,
                    pieceLength: 0,
                    pieceWidth: 0,
                    pieceHeight: 0,
                    totalWeight: 0,
                    CFT: 0
                }
            }
        },
        carrierRemarks: {
           messageQuotes: '',
           displayMessageQuotes: false,
           messageBOL: '',
           displayMessageBOL: false,
        },
        billToInformation: {
            name: user?.billToInformation?.name,
            account: '',
            address: user?.billToInformation?.address,
            address1: user?.billToInformation?.address1,
            city: user?.billToInformation?.city,
            state: user?.billToInformation?.state,
            zipcode: user?.billToInformation?.zipcode,
            country: user?.billToInformation?.country,
            phone: formatPhone(user?.billToInformation?.phone, (user?.billToInformation?.country || 'US')),
        },
        PDFHeaderBranding: {
            name: user?.billToInformation?.name,
            address: user?.billToInformation?.address,
            address1: user?.billToInformation?.address1,
            city: user?.billToInformation?.city,
            state: user?.billToInformation?.state,
            zipcode: user?.billToInformation?.zipcode,
            country: user?.billToInformation?.country,
            phone: formatPhone(user?.billToInformation?.phone, (user?.billToInformation?.country || 'US')),
            PDFBranding: 'company'
        },
        additionalInformation: {
            'MC#': '',
            'EIN#': '',
            APCode: '',
            'USBond#': '',
            SCAC: '',
            'DOT#': '',
            'REF#': ''
        }
    }

    const validatePhoneNumberFormik = (value) => {
        if(value === null || !value){
          return true
        }else if(typeof value === 'string'){
          if(isPossiblePhoneNumber(value)){
            return true
          }else{
            return false
          }
        }else{
          return true
        }
    }

    const validationsAPIIntegration = (title) => {
        return (
            Yup.string().when("APIList", {
                is: value => {
                    let requiredValuesAPIList = availableApis.find(api => api?.APICode === value)?.requiredValues
                    if(requiredValuesAPIList?.includes(title)){
                        return value.length ? value : false
                    }else{
                        return false
                    }
                },
                then: Yup.string().required("Required")
            })
        )
    }

    const validationSchema = Yup.object().shape({
        mainInformation: Yup.object({
        email: Yup.string().email(),
        name: Yup.string().required('Required'),
        phone: Yup.string().nullable().test("validPhoneNumber", "Invalid phone", (value) => (
            validatePhoneNumberFormik(value)
        )),
        fax: Yup.string().nullable().test("validPhoneNumber", "Invalid phone", (value) => (
            validatePhoneNumberFormik(value)
        )),
        }),
        APIIntegration: Yup.object({
            username: validationsAPIIntegration('username'),
            password: validationsAPIIntegration('password'),
            account: validationsAPIIntegration('account'),
            accessCode: validationsAPIIntegration('accessCode'),
            extraField: validationsAPIIntegration('extraField'),
        }),
        billToInformation: Yup.object({
            phone: Yup.string().nullable().test("validPhoneNumber", "Invalid phone", (value) => (
                validatePhoneNumberFormik(value)
            )),
        })
    })

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        onSubmit: () => {
            if(addOrEditLocal === 'edit'){
                editVendor()
            }else{
                addVendor()
            }
        }
    })

    const addVendor = () => {
        setSaving(true)
        axios.post(`${GET_VENDORS}`, {
            code: formik.values.additionalInformation.APCode,
            name: formik.values.mainInformation.name,
            type: [{id: vendorsTypes.filter(e => e.name === formik.values.mainInformation.vendorType)[0]?.id, code: vendorsTypes.filter(e => e.name === formik.values.mainInformation.vendorType)[0]?.code}],
            quoteRemarks: formik.values.carrierRemarks.messageQuotes,
            quoteRemarksForce: formik.values.carrierRemarks.displayMessageQuotes,
            bookingRemarks: formik.values.carrierRemarks.messageBOL,
            bookingRemarksForce: formik.values.carrierRemarks.displayMessageBOL,
            shipmentMode: formik.values.mainInformation.shipmentMode,
            APICredentials: {
                terms: formik.values.mainInformation.terms,
                billTo: formik.values.mainInformation.billTo,
                API: formik.values.APIIntegration.APIList,
                username: formik.values.APIIntegration.username,
                password: formik.values.APIIntegration.password,
                account: formik.values.APIIntegration.account,
                accessCode: formik.values.APIIntegration.accessCode,
                extraField: formik.values.APIIntegration.extraField,
                restrictions: {
                    originType: 'ALL',
                    destinationType: 'ALL',
                    maximums: {
                        pieces: formik.values.APIIntegration.restrictions.maximums.pieces || 0,
                        pieceWeight: formik.values.APIIntegration.restrictions.maximums.pieceWeight || 0,
                        pieceLength: formik.values.APIIntegration.restrictions.maximums.pieceLength || 0,
                        pieceWidth: formik.values.APIIntegration.restrictions.maximums.pieceWidth || 0,
                        pieceHeight: formik.values.APIIntegration.restrictions.maximums.pieceHeight || 0,
                        totalWeight: formik.values.APIIntegration.restrictions.maximums.totalWeight || 0,
                        CFT: formik.values.APIIntegration.restrictions.maximums.CFT || 0
                    },
                    minimums: {
                        pieces: formik.values.APIIntegration.restrictions.minimums.pieces || 0,
                        pieceWeight: formik.values.APIIntegration.restrictions.minimums.pieceWeight || 0,
                        pieceLength: formik.values.APIIntegration.restrictions.minimums.pieceLength || 0,
                        pieceWidth: formik.values.APIIntegration.restrictions.minimums.pieceWidth || 0,
                        pieceHeight: formik.values.APIIntegration.restrictions.minimums.pieceHeight || 0,
                        totalWeight: formik.values.APIIntegration.restrictions.minimums.totalWeight || 0,
                        CFT: formik.values.APIIntegration.restrictions.minimums.CFT || 0
                    }
                }
            },
            contactInformation: {
                address: formik.values.mainInformation.address,
                address1: formik.values.mainInformation.address1,
                city: formik.values.mainInformation.city,
                state: formik.values.mainInformation.state,
                zipcode: formik.values.mainInformation.zipcode,
                remarks: formik.values.mainInformation.remarks,
                contacts: [{
                    name: formik.values.mainInformation.contactPerson,
                    email: formik.values.mainInformation.email,
                    phone: clearDialCode(formik.values.mainInformation.phone, formik.values.mainInformation.country),
                    fax: clearDialCode(formik.values.mainInformation.fax, formik.values.mainInformation.country),
                    type: 'Main'
                }],
            },
            equipment: formik.values.mainInformation.equipments,
            serviceArea: formik.values.mainInformation.serviceArea,
            billTo: {
                name: formik.values.billToInformation.name,
                account: formik.values.billToInformation.account,
                address: formik.values.billToInformation.address,
                address1: formik.values.billToInformation.address1,
                city: formik.values.billToInformation.city,
                state: formik.values.billToInformation.state,
                zipcode: formik.values.billToInformation.zipcode,
                country: formik.values.billToInformation?.country.length === 3 ? formik.values.billToInformation?.country : CountryOptions.filter(country => country.Code === formik.values.billToInformation?.country)[0]?.CodePrimus,
                phone: clearDialCode(formik.values.billToInformation.phone, formik.values.billToInformation?.country || 'USA'),
                fax: '', 
            },
            headerBranding: {
                name: formik.values.PDFHeaderBranding.name,
                address: formik.values.PDFHeaderBranding.address,
                address1: formik.values.PDFHeaderBranding.address1,
                city: formik.values.PDFHeaderBranding.city,
                state: formik.values.PDFHeaderBranding.state,
                zipcode: formik.values.PDFHeaderBranding.zipcode,
                country: formik.values.PDFHeaderBranding?.country.length === 3 ? formik.values.PDFHeaderBranding?.country : CountryOptions.filter(country => country.Code === formik.values.PDFHeaderBranding?.country)[0]?.CodePrimus,
                phone: clearDialCode(formik.values.PDFHeaderBranding.phone, formik.values.PDFHeaderBranding?.country || 'USA'),
                fax: '', 
                logo: formik.values.PDFHeaderBranding.PDFBranding
            },
            MCNumber: formik.values.additionalInformation['MC#'],
            EINNumber: formik.values.additionalInformation['EIN#'],
            USBondNumber: formik.values.additionalInformation['USBond#'],
            SCAC: formik.values.additionalInformation.SCAC,
            DOTNumber: formik.values.additionalInformation['DOT#'],
            vendorReferenceNumber: formik.values.additionalInformation['REF#']
        }).then((response) => {
            setAddOrEditLocal('edit')
            setCurrentIdRowToEdit(response?.data?.data?.results?.id)
            setSaving(false)
            setSaved(true)
            setTimeout(function(){
                setSaved(false)
                // handleClose()
            }, 2000);
            getData({})
        }).catch(error => {
            setSaving(false)
            checkErrorAPICall(error, dispatch, 'Edit vendor')
        })
    }
    
    const editVendor = () => {
        setSaving(true)
        let currentSelected = rowSelected ? rowSelected?.id : currentIdRowToEdit
        let rowSelectedLocal = rowSelected?.id ? rowSelected : {}
        axios.put(`${GET_VENDORS}/${currentSelected}`, {
            code: formik.values.additionalInformation.APCode,
            name: formik.values.mainInformation.name,
            type: [{id: vendorsTypes.filter(e => e.name === formik.values.mainInformation.vendorType)[0]?.id}],
            quoteRemarks: formik.values.carrierRemarks.messageQuotes,
            quoteRemarksForce: formik.values.carrierRemarks.displayMessageQuotes,
            bookingRemarks: formik.values.carrierRemarks.messageBOL,
            bookingRemarksForce: formik.values.carrierRemarks.displayMessageBOL,
            shipmentMode: formik.values.mainInformation.shipmentMode,
            APICredentials: {
                terms: formik.values.mainInformation.terms,
                billTo: formik.values.mainInformation.billTo,
                API: formik.values.APIIntegration.APIList,
                username: formik.values.APIIntegration.username,
                password: formik.values.APIIntegration.password,
                account: formik.values.APIIntegration.account,
                accessCode: formik.values.APIIntegration.accessCode,
                extraField: formik.values.APIIntegration.extraField,
                restrictions: {
                    originType: 'ALL',
                    destinationType: 'ALL',
                    maximums: {
                        pieces: formik.values.APIIntegration.restrictions.maximums.pieces || 0,
                        pieceWeight: formik.values.APIIntegration.restrictions.maximums.pieceWeight || 0,
                        pieceLength: formik.values.APIIntegration.restrictions.maximums.pieceLength || 0,
                        pieceWidth: formik.values.APIIntegration.restrictions.maximums.pieceWidth || 0,
                        pieceHeight: formik.values.APIIntegration.restrictions.maximums.pieceHeight || 0,
                        totalWeight: formik.values.APIIntegration.restrictions.maximums.totalWeight || 0,
                        CFT: formik.values.APIIntegration.restrictions.maximums.CFT || 0
                    },
                    minimums: {
                        pieces: formik.values.APIIntegration.restrictions.minimums.pieces || 0,
                        pieceWeight: formik.values.APIIntegration.restrictions.minimums.pieceWeight || 0,
                        pieceLength: formik.values.APIIntegration.restrictions.minimums.pieceLength || 0,
                        pieceWidth: formik.values.APIIntegration.restrictions.minimums.pieceWidth || 0,
                        pieceHeight: formik.values.APIIntegration.restrictions.minimums.pieceHeight || 0,
                        totalWeight: formik.values.APIIntegration.restrictions.minimums.totalWeight || 0,
                        CFT: formik.values.APIIntegration.restrictions.minimums.CFT || 0
                    }
                }
            },
            contactInformation: {
                address: formik.values.mainInformation.address,
                address1: formik.values.mainInformation.address1,
                city: formik.values.mainInformation.city,
                state: formik.values.mainInformation.state,
                zipcode: formik.values.mainInformation.zipcode,
                contacts:  rowSelectedLocal?.id ? (rowSelectedLocal?.contactInformation?.contacts || {}).map((contact, index) => {
                    if(index === 0){
                        return {
                            name: formik.values.mainInformation.contactPerson,
                            email: formik.values.mainInformation.email,
                            phone: formik.values.mainInformation.phone,
                            fax: clearDialCode(formik.values.mainInformation.fax, formik.values.mainInformation.country),
                            type: "Main"
                        }
                    }else {
                        return contact
                    }
                }) : [{
                    name: formik.values.mainInformation.contactPerson,
                    email: formik.values.mainInformation.email,
                    phone: clearDialCode(formik.values.mainInformation.phone, formik.values.mainInformation.country),
                    fax: clearDialCode(formik.values.mainInformation.fax, formik.values.mainInformation.country),
                    type: "Main"
                }],
                remarks: formik.values.mainInformation.remarks
            },
            equipment: formik.values.mainInformation.equipments,
            serviceArea: formik.values.mainInformation.serviceArea,
            billTo: {
                name: formik.values.billToInformation.name,
                account: formik.values.billToInformation.account,
                address: formik.values.billToInformation.address,
                address1: formik.values.billToInformation.address1,
                city: formik.values.billToInformation.city,
                state: formik.values.billToInformation.state,
                zipcode: formik.values.billToInformation.zipcode,
                country: CountryOptions.filter(country => country.Code === formik.values.billToInformation?.country)[0]?.CodePrimus,
                phone: formik.values.billToInformation.phone,
            },
            headerBranding: {
                name: formik.values.PDFHeaderBranding.name,
                address: formik.values.PDFHeaderBranding.address,
                address1: formik.values.PDFHeaderBranding.address1,
                city: formik.values.PDFHeaderBranding.city,
                state: formik.values.PDFHeaderBranding.state,
                zipcode: formik.values.PDFHeaderBranding.zipcode,
                country: formik.values.PDFHeaderBranding?.country.length === 3 ? formik.values.PDFHeaderBranding?.country : CountryOptions.filter(country => country.Code === formik.values.PDFHeaderBranding?.country)[0]?.CodePrimus,
                phone: clearDialCode(formik.values.PDFHeaderBranding.phone, formik.values.PDFHeaderBranding?.country || 'USA'),
                logo: formik.values.PDFHeaderBranding.PDFBranding
            },
            MCNumber: formik.values.additionalInformation['MC#'],
            EINNumber: formik.values.additionalInformation['EIN#'],
            USBondNumber: formik.values.additionalInformation['USBond#'],
            SCAC: formik.values.additionalInformation.SCAC,
            DOTNumber: formik.values.additionalInformation['DOT##'],
            vendorReferenceNumber: formik.values.additionalInformation['REF#']
        }).then(() => {
            setSaving(false)
            setSaved(true)
            setTimeout(function(){
                setSaved(false)
            }, 2000);
            getData({})
        }).catch(error => {
            setSaving(false)
            checkErrorAPICall(error, dispatch, 'Edit vendor')
        })
    }

    useEffect(() => {
        if(rowSelected?.id){
            formik.setValues({
                mainInformation: {
                    name: rowSelected?.name,
                    terms: rowSelected.APICredentials?.terms,
                    billTo: rowSelected.APICredentials?.billTo,
                    address: rowSelected.contactInformation?.address,
                    address1: rowSelected.contactInformation?.address1,
                    city: rowSelected.contactInformation?.city,
                    state: rowSelected.contactInformation?.state,
                    zipcode: rowSelected.contactInformation?.zipcode,
                    country: 'US',
                    phone: formatPhone(rowSelected.contactInformation?.contacts?.filter(contact => contact.type === 'Main')[0]?.phone, 'US'),
                    fax: formatPhone(rowSelected.contactInformation?.contacts?.filter(contact => contact.type === 'Main')[0]?.fax, 'US'),
                    contactPerson: rowSelected.contactInformation?.contacts?.filter(contact => contact.type === 'Main')[0]?.name,
                    email: rowSelected.contactInformation?.contacts?.filter(contact => contact.type === 'Main')[0]?.email,
                    vendorType: '',
                    shipmentMode: {},
                    remarks: rowSelected.contactInformation?.remarks,
                    equipments: rowSelected.equipment || [],
                    serviceArea: rowSelected.serviceArea || []
                },
                APIIntegration: {
                    APIList: '',
                    username: rowSelected.APICredentials?.username,
                    password: rowSelected.APICredentials?.password,
                    account: rowSelected.APICredentials?.account,
                    accessCode: rowSelected.APICredentials?.accessCode,
                    extraField: rowSelected.APICredentials?.extraField,
                    restrictions: {
                        maximums: {
                            pieces: rowSelected.APICredentials?.restrictions?.maximums?.pieces,
                            pieceWeight: rowSelected.APICredentials?.restrictions?.maximums?.pieceWeight,
                            totalWeight: rowSelected.APICredentials?.restrictions?.maximums?.totalWeight,
                            pieceLength: rowSelected.APICredentials?.restrictions?.maximums?.pieceLength,
                            pieceWidth: rowSelected.APICredentials?.restrictions?.maximums?.pieceWidth,
                            pieceHeight: rowSelected.APICredentials?.restrictions?.maximums?.pieceHeight,
                            CFT: rowSelected.APICredentials?.restrictions?.maximums?.CFT,
                        },
                        minimums: {
                            pieces: rowSelected.APICredentials?.restrictions?.minimums?.pieces,
                            pieceWeight: rowSelected.APICredentials?.restrictions?.minimums?.pieceWeight,
                            totalWeight: rowSelected.APICredentials?.restrictions?.minimums?.totalWeight,
                            pieceLength: rowSelected.APICredentials?.restrictions?.minimums?.pieceLength,
                            pieceWidth: rowSelected.APICredentials?.restrictions?.minimums?.pieceWidth,
                            pieceHeight: rowSelected.APICredentials?.restrictions?.minimums?.pieceHeight,
                            CFT: rowSelected.APICredentials?.restrictions?.minimums?.CFT,
                        }
                    }
                },
                carrierRemarks: {
                   messageQuotes: rowSelected.quoteRemarks,
                   displayMessageQuotes: rowSelected.quoteRemarksForce,
                   messageBOL: rowSelected.bookingRemarks,
                   displayMessageBOL: rowSelected.bookingRemarksForce,
                },
                billToInformation: {
                    name: rowSelected.billTo?.name,
                    account: rowSelected.billTo?.account,
                    address: rowSelected.billTo?.address,
                    address1: rowSelected.billTo?.address1,
                    city: rowSelected.billTo?.city,
                    state: rowSelected.billTo?.state,
                    zipcode: rowSelected.billTo?.zipcode,
                    country: rowSelected.billTo?.country || 'USA',
                    phone: formatPhone(rowSelected.billTo?.phone, rowSelected.billTo?.country || 'USA'),
                },
                PDFHeaderBranding: {
                    name: rowSelected.headerBranding?.name,
                    address: rowSelected.headerBranding?.address,
                    address1: rowSelected.headerBranding?.address1,
                    city: rowSelected.headerBranding?.city,
                    state: rowSelected.headerBranding?.state,
                    zipcode: rowSelected.headerBranding?.zipcode,
                    country: rowSelected.headerBranding?.country || 'USA',
                    phone: formatPhone(rowSelected.headerBranding?.phone, rowSelected.headerBranding?.country || 'USA'),
                    PDFBranding: rowSelected.headerBranding?.logo || 'company'
                },
                additionalInformation: {
                    'MC#': rowSelected.MCNumber || '',
                    'EIN#': rowSelected.EINNumber || '',
                    APCode: rowSelected.code || '',
                    'USBond#': rowSelected.USBondNumber || '',
                    SCAC: rowSelected.SCAC || '',
                    'DOT#': rowSelected.DOTNumber || '',
                    'REF#': rowSelected.vendorReferenceNumber || '',
                }
            })
        }else{
            formik.setFieldValue(`billToInformation`, {
                name: user?.billToInformation?.name,
                account: '',
                address: user?.billToInformation?.address,
                address1: user?.billToInformation?.address1,
                city: user?.billToInformation?.city,
                state: user?.billToInformation?.state,
                zipcode: user?.billToInformation?.zipcode,
                country: user?.billToInformation?.country,
                phone: formatPhone(user?.billToInformation?.phone, (user?.billToInformation?.country || 'US')),
            })
           
            formik.setFieldValue(`PDFHeaderBranding`, {
                name: user?.billToInformation?.name,
                address: user?.billToInformation?.address,
                address1: user?.billToInformation?.address1,
                city: user?.billToInformation?.city,
                state: user?.billToInformation?.state,
                zipcode: user?.billToInformation?.zipcode,
                country: user?.billToInformation?.country,
                phone: formatPhone(user?.billToInformation?.phone, (user?.billToInformation?.country || 'US')),
                PDFBranding: 'company'
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowSelected])

    const testConnection = () => {
        const requiredValues = availableApis?.find(api => api?.APICode === formik.values.APIIntegration.APIList)?.requiredValues
        let errorInValues = false

        requiredValues?.forEach((value) => {
            if(!formik.values.APIIntegration[value]){
                formik.setFieldError(`APIIntegration.${value}`, 'Required')
                formik.setFieldTouched(`APIIntegration.${value}`, true)
                errorInValues = true
            }else{
                formik.setFieldError(`APIIntegration.${value}`, '')
                formik.setFieldTouched(`APIIntegration.${value}`, false)
                errorInValues = false
            }
        })

        if(!formik.values.APIIntegration.APIList){
            formik.setFieldError(`APIIntegration.APIList`, 'Required')
            errorInValues = true
        }

        if(!errorInValues){
            setTestingConnection(true)
            axios.get(TEST_CONNECTION, {
                params: {
                    vendorInformation: {
                        method: formik.values.APIIntegration.APIList === 'none' ? '' : formik.values.APIIntegration.APIList || '',
                        account: formik.values.APIIntegration.account || '',
                        username: formik.values.APIIntegration.username || '',
                        password: formik.values.APIIntegration.password || '',
                        accessCode: formik.values.APIIntegration.accessCode || '',
                        extraField: formik.values.APIIntegration.extraField || '',
                        terms: formik.values.mainInformation.terms || '',
                        billTo: formik.values.mainInformation.billTo || ''
                    }
                }
            })
            .then((results) => {
                setTestingConnection(false)
                if(results?.data?.data?.results?.success){
                    dispatch({type: actionTypes.SetAxiosSuccess, payload: 'Carrier API connected succesfully'})
                }
            }).catch(error => {
                setTestingConnection(false)
                checkErrorAPICall(error, dispatch, 'Test Connection')
            })
        }

    }

    useEffect(() => {
      setCurrentIdRowToEdit(rowSelected?.id || null)
    }, [rowSelected])
    

    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paperEditModalSI} style={{visibility: 'visible', opacity: '100%'}}>
                    <div className="row modal-header p-0 pb-2">
                        <div className="col-8">
                            <h5 className="modal-title">{addOrEdit === 'edit' ? 'Edit' : 'Add New'} Vendor</h5>
                        </div>
                        <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={handleClose}>
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <>
                        <div style={{maxHeight: 615, overflowY: 'scroll', overflowX: 'hidden'}}>
                            <div className='row mt-5 mb-7'>
                                <div className="col-12">
                                    <h6>Main Information</h6>
                                </div>
                            </div>
                            <MainInformation
                                formik={formik}
                                rowSelected={rowSelected}
                                vendorsTypes={vendorsTypes}
                                setVendorsTypes={setVendorsTypes}
                            />

                            <div className='row mt-10 mb-7'>
                                <div className="col-12">
                                    <h6>API Integration</h6>
                                </div>
                            </div>

                            <APIIntegration
                                APISelected={APISelected}
                                setAPISelected={setAPISelected}
                                formik={formik}
                                testConnection={testConnection}
                                testingConnection={testingConnection}
                                rowSelected={rowSelected}
                                availableApis={availableApis}
                                setAvailableApis={setAvailableApis}
                            />

                            <div className='row mt-10 mb-7'>
                                <div className="col-12">
                                    <h6>Carrier Remarks</h6>
                                </div>
                            </div>
                            <CarrierRemarks
                                formik={formik}
                            />

                            <div className='row mt-10 mb-7'>
                                <div className="col-12">
                                    <h6>Bill To Information</h6>
                                </div>
                            </div>
                            <BillToInformation
                                formik={formik}
                            />

                            <div className='row mt-10 mb-7'>
                                <div className="col-12">
                                    <h6>PDF Header branding</h6>
                                </div>
                            </div>
                            <PDFHeaderBranding
                                formik={formik}
                            />
                        </div>

                        <div className="row mb-3 mt-7">
                            <div className="col-12 d-flex justify-content-end">
                                <button
                                    className="btn btn-secondary me-4"
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                                <button
                                    className={`btn ${saved ? 'btn-success' : 'btn-primary'} d-flex align-items-center`}
                                    style={{
                                        cursor: saved ? 'auto' : 'pointer',
                                        transition: 'background-color 0.5s ease'
                                    }}
                                    type='submit'
                                    onClick={() => {
                                        formik.handleSubmit()
                                    }}
                                >
                                    {saving ? 'Saving' : saved ? 'Saved' : 'Save'}{saving && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                </button>
                            </div>
                        </div>
                    </>
                </div>
            </Fade>
        </ModalStyled>
    )
}

export default EditModal